const operationsDescriptor = {
    key: 'operations-expenses',
    title: 'Operations Expenses',
    subtitle: 'Overview of operational spending and trends',
    description: 'Track vendor payments, invoices, and operational spend patterns to keep run-rate predictable and spot cost optimizations.',
    badge: { direction: 'down', text: '' },
    kpis: [
        { label: 'Total Operations Cost', value: '', subtext: '', subColor: '#eb9d00' },
        { label: 'Perfect P&L Variance', value: '', subtext: '', subColor: '#eb9d00' },
        { label: 'Perfect P&L Income', value: '', subtext: '', subColor: '#43a047' },
    ],
    alert: {
        title: "You're doing great on operations costs!",
        body: "Your operations expenses have decreased by 3.2% this month and you're running $850 under budget. This is a healthy sign. Quick Tip: Your operations costs are at 12.9% of revenue — better than the industry average of 15–18%. This gives you more room to invest in growth.",
    },
    lineChart: {
        label: 'Ops Spend',
        values: [],
        target: null,
    },
    donut: {
        slices: [],
    },
    table: {
        rows: [],
        total: { thisMonth: null, lastMonth: null, changePct: null },
    },
    vendors: [],
};

export default operationsDescriptor;
